// extracted by mini-css-extract-plugin
export var avatarContainer = "_55-1";
export var largeAvatarContainer = "_55-2";
export var smallAvatarContainer = "_55-0";